import {
  CommonModule,
  CurrencyPipe,
  registerLocaleData,
} from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeUs from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FuseProgressBarModule } from 'src/@fuse/components';
import { FuseSidebarModule } from 'src/@fuse/components/sidebar/sidebar.module';
import { FuseModule } from 'src/@fuse/fuse.module';
import { FuseSharedModule } from 'src/@fuse/shared.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { fuseConfig } from 'src/app/fuse-config';
import { LayoutModule } from 'src/app/layout/layout.module';

import { TokenInterceptor } from './auth/token-interceptor.service';
import { GraphqlModule } from './graphql/graphql.module';
import { ChatMensajesService } from './main/pages/services/chat-mensajes.service';
import { ChatService } from './main/pages/services/chat.service';
import { ContactosUsersService } from './main/pages/services/contactos-users.service';
import { ContactosService } from './main/pages/services/contactos.service';
import { ServicesModule } from './main/pages/services/services.module';
import { UsersConfiguracionesService } from './main/pages/services/user-configuraciones.service';
import { UserService } from './main/pages/services/user.service';
import { metaReducers, reducers } from './store';

registerLocaleData(localeUs);

@NgModule({
  declarations: [AppComponent],

  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatButtonModule,
    MatSnackBarModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    LayoutModule,
    ServicesModule,
    GraphqlModule,

    //FuseComponent
    FuseModule.forRoot(fuseConfig),
    FuseSidebarModule,
    FuseProgressBarModule,
    FuseSharedModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    StoreDevtoolsModule.instrument(),

    TranslateModule.forRoot(),
  ],
  providers: [
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 1000 } },
    UserService,
    UsersConfiguracionesService,
    ChatService,
    ChatMensajesService,
    ContactosService,
    ContactosUsersService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    CurrencyPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
